module.exports = __webpack_public_path__ + "img/45.0b49f59b.jpg";